import { render, staticRenderFns } from "./SentNotificationModal.vue?vue&type=template&id=33bbe052&scoped=true&"
import script from "./SentNotificationModal.vue?vue&type=script&lang=js&"
export * from "./SentNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./SentNotificationModal.vue?vue&type=style&index=0&id=33bbe052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bbe052",
  null
  
)

export default component.exports